/**
 * Helpful math functions
 */
export class AgprMath {

    /**
     * Rounds to the provided decimal place
     */
    public static round = (floatValue: number, decimalPlaces: number = 2) => {
        if (decimalPlaces === 0) {
            return Math.round(floatValue);
        }
        const decimalValue = Math.pow(10, decimalPlaces);

        return Math.round(floatValue * decimalValue) / decimalValue;
    };

    /**
     * Returns the percentage change between two numbers.
     * Handles divide by zero as NaN
     */
    public static percentageChange = (currentData: number, previousData: number, decimalPlaces: number = 1): number => {
        // when the denominator value is zero, percentage change has no meaning since its outside the defined boundary of rate
        // Going from 'not being', into 'being' is not a change of being, rather a creation of being 🤯
        if (previousData === 0) {
            return NaN;
        }
        // When dealing with numbers with different signs (+ and -), the % change only measures after you cross the zero line.
        // This is because the % change before you cross the zero line is always 100% ... spooky
        return AgprMath.round(100 * ((currentData - previousData) / Math.abs(previousData)), decimalPlaces);
    };

    /**
     * Divides 2 numbers and handle divide by zero by returning NaN
     */
    public static safeDivide = (numberator: number, denominator: number): number => {
        if (denominator === 0) {
            return NaN;
        }

        return numberator / denominator;
    };
}
